import { render, staticRenderFns } from "./order-item.vue?vue&type=template&id=1a003be3&scoped=true"
import script from "./order-item.vue?vue&type=script&lang=js"
export * from "./order-item.vue?vue&type=script&lang=js"
import style0 from "./order-item.vue?vue&type=style&index=0&id=1a003be3&prod&scoped=true&lang=less"
import style1 from "./order-item.vue?vue&type=style&index=1&id=1a003be3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a003be3",
  null
  
)

export default component.exports